import AddressService from 'web-core/src/address-service';
import { updateApp } from 'client/actions/ifpApps';
import _ from 'lodash';

export const SAVE_ADDRESS = 'SAVE_ADDRESS';
export const SAVE_MAILING_ADDRESS = 'SAVE_MAILING_ADDRESS';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';

const save = address => ({
  type: SAVE_ADDRESS,
  address,
});

const receiveMailingAddress = (address, memberId) => ({
  type: SAVE_MAILING_ADDRESS,
  address,
  memberId,
});

const removeAddress = addressId => ({
  type: DELETE_ADDRESS,
  addressId,
});

export const getAddress = address => (dispatch, getState, { apiClient }) => {
  const svc = new AddressService({ client: apiClient });
  return svc.get(address).then(response => response.address);
};

export const saveToApps = (address, appIds) => (dispatch) => {
  dispatch(save(address));
  appIds.forEach(appId => dispatch(updateApp(appId, { address })));
};

export const saveAddress = address => (dispatch, getState, { apiClient }) => {
  const svc = new AddressService({ client: apiClient });
  return svc.save({ address }).then((response) => {
    dispatch(save(response.address));
    return response.address;
  });
};

export const saveAddressToApp = (payload, options) => (dispatch, getState, { apiClient }) => {
  const svc = new AddressService({ client: apiClient });
  const appIds = payload.app_ids;

  // Pick out valid app ids
  const validAppIds = _.reject(appIds, id => id === 'vision');
  if (options && options.member_id && validAppIds.length) {
    return svc.saveToApp(payload, options).then((response) => {
      dispatch(saveToApps(response.address, validAppIds));
      return response.address;
    });
  }

  dispatch(saveToApps(payload.address, appIds));
  return Promise.resolve(payload.address);
};

export const saveMailingAddress = (payload, options) => (dispatch, getState, { apiClient }) => {
  const svc = new AddressService({ client: apiClient });
  const { member_id } = options;

  if (options && options.member_id && payload.is_mailing) {
    const request = !_.get(payload, 'address.id')
      ? svc.saveMailingAddress(payload, options)
      : svc.save(payload);

    return request.then((response) => {
      dispatch(receiveMailingAddress(response.address, member_id));
      return response;
    });
  }
  /* eslint-disable prefer-promise-reject-errors */
  return Promise.reject({
    err: 'Either member ID not specified or not specified as mailing address',
  });
};

export const deleteAddress = (addressId, options) => (dispatch, getState, { apiClient }) => {
  const svc = new AddressService({ client: apiClient });
  return svc.deleteAddress(addressId, options).then((success) => {
    if (success) {
      dispatch(removeAddress(addressId));
    }
    return success;
  });
};
